<template>
    <div class="contents">
        <div class="container-fluid">
            <FollowUpNavigation />
            <div class="row">
                <div class="col-lg-12">
                    <div class="breadcrumb-main user-member justify-content-sm-between">
                        <div class="d-flex flex-wrap justify-content-center breadcrumb-main__wrapper">
                            <div class="d-flex align-items-center user-member__title justify-content-center mr-sm-25">
                                <h4 class="text-capitalize fw-500 breadcrumb-title">
                                    Edit Follow Up
                                </h4>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="userDatatable global-shadow border p-30 bg-white radius-xl w-100 mb-30">
                        <FollowUpForm :isEdit="true" :followUpId="followUpId" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FollowUpForm from "@/components/forms/followup/FollowUpForm.vue";
import FollowUpNavigation from "@/components/followup/Navigation.vue";

export default {
    components: {
        FollowUpForm,
        FollowUpNavigation
    },
    data() {
        return {
            followUpId: null
        };
    },
    mounted() {
        this.followUpId = this.$route.query.id;
    }
};
</script>


